import { render } from "./PropertyVerification.vue?vue&type=template&id=5c7b66b5&scoped=true"
import script from "./PropertyVerification.vue?vue&type=script&lang=js"
export * from "./PropertyVerification.vue?vue&type=script&lang=js"

import "./PropertyVerification.vue?vue&type=style&index=0&id=5c7b66b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c7b66b5"]])

export default __exports__